import INCLUDES_POLICIES_JSON from "../schemas/includes_policies";


export const INCLUDES_POLICIES = INCLUDES_POLICIES_JSON;

const getIdsFromNumber = (number) => {
    const binaryString = number.toString(2);
    const binaryArray = binaryString.split("");
    const binaryArrayReversed = binaryArray.reverse();
    const ids = getIds();
    const idsArray = [];
    binaryArrayReversed.forEach((bit, index) => {
        if (bit === "1") {
            idsArray.push(ids[index]);
        }
    });
    return idsArray;
};

const getIds = () => [...Object.values(INCLUDES_POLICIES).map(policy => policy.id)];


// autogenerate on load
const includes_policies_copy = {}
Object.values(INCLUDES_POLICIES).forEach(value => {
    includes_policies_copy[value.id] = value.xlat;
});

export const includes_policies = includes_policies_copy;


export const getTranslatedName = (payment_methods, id, lang) => {
    let language = lang.substring(0,2);
    if (language !== 'es' && language!== 'en') { language = 'en'; }
    return includes_policies[id][language].name
};

// const getTranslatedDescription = (id, language) => this.includes_policies[id][language].desc;

export const getTranslatedNameFromNumber = (includes_policies, number, language) => {
    const ids = getIdsFromNumber(number);
    const names = ids.map(id => getTranslatedName(includes_policies, id, language));
    return names;
};